import {KTSVG} from '@metronic/helpers'
import {useListView} from '../providers/ListViewProvider'
import {useIntl} from "react-intl";

const UserEditModalHeader = () => {
  const {setItemIdForUpdate, itemIdForUpdate} = useListView()
  const intl = useIntl()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{itemIdForUpdate?intl.formatMessage({id: 'EDIT_USER'}):intl.formatMessage({id: 'ADD_USER'})}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {UserEditModalHeader}
